/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OpenstackTenant {
    getFixupPrototypeFunction() { return OpenstackTenant.fixupPrototype; }

    static newInstance(model: Partial<OpenstackTenant>): OpenstackTenant {
        let obj = Object.assign(new OpenstackTenant(), model);
        OpenstackTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OpenstackTenant>): OpenstackTenant {
        if (!model) return null;
        return OpenstackTenant.newInstance(<OpenstackTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OpenstackTenant) {
        if (!obj) return;

        models.OpenstackTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OpenstackTenant): boolean {
        Object.setPrototypeOf(obj, OpenstackTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Tenant Name
     */
    name: string;

    /**
     * Tenant Domain
     */
    domain_id: string;

}
